export function staticContentHasErrored(state = false, action) {
  switch (action.type) {
    case 'STATIC_CONTENT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function staticContentIsLoading(state = false, action) {
  switch (action.type) {
    case 'STATIC_CONTENT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function staticContent(state = false, action) {
  switch (action.type) {
    case 'STATIC_CONTENT_FETCH_DATA_SUCCESS':
      return action.staticContent;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/static_content.js